// tslint:disable-next-line:variable-name
export const openCoachingForm = (id: number, attrs: { ai?: string, abbr_survey?: string, survey?: string, canFlag?: boolean, is_flagged?: boolean, isCommentHidden?: boolean, flagEdit?: boolean, isFlagged?: number, uchc?: number, userCanHideComment?:boolean, hasCommentHidden?: boolean }) => {
  const options = 'width=800,height=800,scrollbars=1,resizable=1'
  const backQS = attrs.survey ? 'cd' : 'co'

  if(attrs.isFlagged == 1){
    var flagged = true;
  } else {
    var flagged = false;
  }

  if(attrs.uchc == 1){
    var uchc = true;
  } else {
    var uchc = false;
  }

  
  const isCommentHidden = attrs.isCommentHidden || attrs.hasCommentHidden
  const isFlagged = attrs.is_flagged || flagged
  const canFlag = attrs.canFlag || attrs.flagEdit
  const userCanHideComment = attrs.userCanHideComment || uchc

  if(canFlag){
    if(userCanHideComment && isCommentHidden){
      var page = `coaching_form?back=${backQS}&id=${id}&canFlag=${canFlag}&isFlagged=${isFlagged}&isCommentHidden=${isCommentHidden}`
    } else{
      var page = `coaching_form?back=${backQS}&id=${id}&canFlag=${canFlag}&isFlagged=${isFlagged}`
    }
  }else{
    var page = `coaching_form?back=${backQS}&id=${id}`
  }
  

  if (attrs.ai) {
    const isActionItem = attrs.ai === '1'
    page += `&ai=${isActionItem}`
  }

  if (attrs.abbr_survey) {
    page += `&survey=${attrs.abbr_survey}`
  }

  if (attrs.survey) {
    page += `&survey=${attrs.survey}`
  }
  window.open(page, '', options)
}
